(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-renly-header]').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const trigger = header.querySelector('[data-renly-menu-open]');
      const dialog = header.querySelector('[data-renly-menu-dialog]');
      let previousOverflow = '';
      trigger.addEventListener('click', () => {
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
      });
      header.querySelector('[data-renly-menu-close]').addEventListener('click', () => dialog.close());
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
    });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const count = event.cartData?.item_count;
      if (Number.isFinite(count)) document.querySelectorAll('[data-renly-header] [data-cart-count]').forEach(node => { node.textContent = count; });
    });
  }
})();
